import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStars = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.5 2.5H15.5M13.5 0.5V4.5M0.5 13.5H4.5M2.5 11.5V15.5M8 2L9.4 6.6L14 8L9.4 9.4L8 14L6.6 9.4L2 8L6.6 6.6L8 2Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgStars;
